import React from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Accordion } from "react-bootstrap";
import EachNotification from './EachNotification';

const PurchaseOrderNotifConf = (props) =>{
    const t = useTranslate();

    if(props.moduleAdmin.params.po.active){
        return (
            <Accordion className='mb-2'>
                <Accordion.Item eventKey='po'>
                    <Accordion.Header>
                        <span style={{color:props.notificationsType.po.bg, fontWeight:'bold',fontSize:'0.9rem'}}>
                            {t('po')}&nbsp;
                            <i style={{color:props.notificationsType.po.bg}} className={`${props.notificationsType.po.icon} header-icon fs-5`}></i>
                        </span>
                    </Accordion.Header>
                    <Accordion.Body>
                        <span>{t('noConfAvailable')}</span>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        )
    }else{
        return(<></>)
    }
};

export default PurchaseOrderNotifConf;